import { render, staticRenderFns } from "./MyClaims.vue?vue&type=template&id=61e1c1f7&"
import script from "./MyClaims.vue?vue&type=script&lang=js&"
export * from "./MyClaims.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports